import { useState } from "react";

import ClientOnly from "@hl/base-components/lib/ClientOnly";
import {
  Box,
  Button,
  Group,
  MantineProvider,
  Overlay,
  Stack,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { ArrowLeft } from "~/../../base-components/lib/assets/icons/HDS";
import { SECONDARY_COLOR } from "~/../../base-components/lib/theme/button";
import { AppSEO } from "~/../../shared-features/lib/features/layout";

import { TOOLS_URL } from "config";

import { CurationBuilder } from "./builder/CurationBuilder";
import { CurationViewer } from "./builder/CurationViewer";

export const CreateCuration = () => {
  const [testHtml, setTestHtml] = useState<string | null>(
    null && "<div><h1>Hello World</h1></div>"
  );

  return (
    <>
      <AppSEO title="Create Curation" />
      {/* <AppShell
        padding="md"
        header={
          <AppHeader
            leftButtons={
              <Link to={TOOLS_URL.curations.list}>
                <Button
                  color={SECONDARY_COLOR}
                  leftIcon={<ArrowLeft height={12} />}
                >
                  Back
                </Button>
              </Link>
            }
          />
        }
        // footer={<AppFooter />}
      > */}
      <ClientOnly>
        <MantineProvider inherit withCSSVariables>
          {/* <Container size="sm" mb={116}>
              hi
            </Container> */}

          <Box
            sx={{
              height: "100dvh",
              maxHeight: "100dvh",
              minHeight: "100dvh",
              width: "100%",
              maxWidth: "100%",
              minWidth: "100%",
              "--var-builder-panel-color": "var(--mantine-color-white)",
            }}
          >
            <Stack h={"100%"} w={"100%"} spacing={0}>
              <Box h={56}>
                <Link to={TOOLS_URL.curations.list}>
                  <Button
                    color={SECONDARY_COLOR}
                    leftIcon={<ArrowLeft height={12} />}
                  >
                    Back
                  </Button>
                </Link>
              </Box>
              <Box h={"100%"} mah={"calc(100% - 56px)"}>
                <CurationBuilder
                  onSetHtml={(html) => {
                    setTestHtml(html);
                  }}
                  onSave={async ({ css, html, data }) => {
                    console.log("Save", { css, html, data });
                  }}
                  onShowPreview={() => {
                    console.log("Show Preview");
                  }}
                />
              </Box>
            </Stack>

            {testHtml != null && (
              <Overlay sx={{ opacity: 1 }}>
                <Group
                  position="center"
                  py={"sm"}
                  bg={"gray.2"}
                  sx={{
                    borderBottom: "1px solid var(--mantine-color-gray-3)",
                  }}
                >
                  <Button
                    onClick={() => {
                      setTestHtml(null);
                    }}
                  >
                    Close Preview
                  </Button>
                </Group>
                <CurationViewer html={testHtml!} />
              </Overlay>
            )}
          </Box>
        </MantineProvider>
      </ClientOnly>
      {/* </AppShell> */}
    </>
  );
};
